/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
var Dagger = function (quality) {
  return {
    slot: 'weapon',
    type: 'dagger',
    quality: quality,
    damageMod: quality * 0.25,
    dexterity: Math.round(1 + quality * 2.5),
    dodgeChance: quality * 3,
    speed: quality * 0.6,
  };
};
module.exports = Dagger;
